import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ReactComponent as Cancel } from '../../../../Assets/Image/svg/cancel.svg';
import useFetch from '../../../../Hooks/useFetch';
import DragandDropWithoutbtn from '../../../share/dragAndDropFile/DragandDropWithoutbtn';

const CreateDocuments = ({ close, refreshList, selectedDocument }) => {
	console.log('CreateDocuments ~ selectedDocument:', selectedDocument);
	const [file, setFile] = useState({});
	const [data, setData] = useState(undefined);
	const [fileError, setFileError] = useState(false);
	const [teamList, setTeamList] = useState([]);
	const [memberList, setMemberList] = useState([]);

	const getTeamList = useFetch({
		method: 'GET',
		url: `BootCampGroupService/11/groups`,
		noHeader: false,
		trigger: true,
		setter: (data) => {
			setTeamList(data.results);
		},
	});

	const createDocument = useFetch({
		method: 'POST',
		url: `CertificateService`,
		noHeader: false,
		trigger: false,
		data: data,
		caller: refreshList,
	});

	const {
		register,
		handleSubmit,
		reset,
		setValue,
		formState: { errors },
	} = useForm({
		defaultValues: {
			team: teamList,
			member: '',
			document: selectedDocument?.type,
		},
	});

	const updateDocument = useFetch({
		method: 'PUT',
		url: `CertificateService/${selectedDocument?.id}`,
		noHeader: false,
		trigger: false,
		data: data,
		caller: refreshList,
	});

	const handleCloseModal = () => {
		reset({
			team: '',
			member: '',
			document: '',
		});
		setFile({});
		close();
	};

	const onSubmit = (data) => {
		if (!file) {
			setFileError(true);
			return;
		} else {
			setFileError(false);
		}

		let formData = new FormData();
		formData.append('bootcamp', 11);
		formData.append('group', data.team);
		formData.append('user', data.member);
		formData.append('type', data.document);
		// formData.append('file', data.file);
		formData.append('file_name', file[0].name);

		setData(formData);

		if (!selectedDocument) {
			updateDocument.reFetch();
		} else {
			createDocument.reFetch();
		}
		handleCloseModal();
	};

	useEffect(() => {
		setFile(selectedDocument.file_name);

		setValue('document', selectedDocument.type);
		// setValue('member', selectedDocument.);

		teamList.forEach((team) => {
			if (team.group_name == selectedDocument.group_name) {
				setValue('team', team.id);
				setMemberList(team.users);
			}
		});
		memberList.forEach((member) => {
			if (member.username == selectedDocument.username) {
				setValue('member', member.id);
				console.log('memberList.forEach ~ member.id:', member.id);
			}
		});
	}, [selectedDocument]);

	const handleSelectTeam = async (id) => {
		const selectedTeam = await teamList.find((team) => team.id == id);
		setMemberList(selectedTeam.users);
	};

	return (
		<div className='relative   '>
			<button
				onClick={() => handleCloseModal()}
				className='AddnewsupportTicket-cancel absolute  '
			>
				<div>
					<Cancel />
				</div>
			</button>
			<h3 className=' text-center text-[#77498F] text-[20px] font-bold mb-20'>
				ثبت مدرک جدید
			</h3>
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className='flex items-center gap-x-10 mb-[3rem] flex-wrap'>
					<h6 className='text-[1.8rem] text-light-prim1'>نوع مدرک:</h6>
					<div className='flex items-center'>
						<input
							{...register('document', { required: true })}
							type='radio'
							className='PriceForm w-10 input'
							value='EndCourse'
							// onChange={(e) => setOffType(e.target.value)}
						/>
						<label className='text-[1.4rem] mr-3' htmlFor='1'>
							مدرک پایان دوره
						</label>
					</div>
					<div className='flex items-center'>
						<input
							{...register('document', { required: true })}
							type='radio'
							className='PriceForm w-10 input'
							value='Participant'
							// onChange={(e) => setOffType(e.target.value)}
						/>
						<label className='text-[1.4rem] mr-3' htmlFor='1'>
							گوهی حضور
						</label>
					</div>
					<div className='flex items-center'>
						<input
							{...register('document', { required: true })}
							type='radio'
							className='PriceForm w-10 input'
							value='BestTeam'
							// onChange={(e) => setOffType(e.target.value)}
						/>
						<label className='text-[1.4rem] mr-3' htmlFor='1'>
							تیم برتر
						</label>
					</div>
					<p className='basis-full text-[1.4rem] text-red-500'>
						{errors['document'] && 'مدرک مورد نظر خود را انتخاب کنید'}
					</p>
				</div>
				<div className='mb-[2rem]'>
					<DragandDropWithoutbtn
						setFile={setFile}
						message='یک فایل برای مدرک انتخاب کنید'
						error={fileError}
					/>
				</div>
				<div className='mb-[2rem]'>
					<select
						{...register('team', {
							required: true,
							onChange: (e) => {
								handleSelectTeam(e.target.value);
							},
						})}
						type='text'
						name='team'
						// control={control}
						className='input border-gray h-[6.4rem] w-full text-[#21212199] bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] '
					>
						<option disabled value='' hidden>
							نام تیم
						</option>
						{teamList?.map((team) => {
							return (
								<option key={team.id} value={team.id}>
									{team.group_name}
								</option>
							);
						})}
					</select>
					<p className='flex-auto text-[1.4rem] text-red-500'>
						{errors['team'] && 'تیم مورد نظر خود را انتخاب کنید'}
					</p>
				</div>
				<div className='mb-[2rem]'>
					<select
						{...register('member', { required: true })}
						type='text'
						name='member'
						// control={control}
						className='input border-gray h-[6.4rem] w-full text-[#21212199] bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] '
					>
						<option disabled value='' hidden>
							نام فرد
						</option>
						{memberList?.map((member) => {
							return (
								<option key={member.id} value={member.id}>
									{member.username}
								</option>
							);
						})}
					</select>
					<p className='flex-auto text-[1.4rem] text-red-500'>
						{errors['member'] && 'نام فرد مورد نظر خود را انتخاب کنید'}
					</p>
				</div>
				<button
					className='w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer mx-auto'
					type='submit'
				>
					<span>ثبت</span>
				</button>
			</form>
		</div>
	);
};
export default CreateDocuments;
